export const DraftManifestTypes = {
  ADD_WAYBILLNUMBER_TO_DRAFTMANIFEST: "ADD_WAYBILLNUMBER_TO_DRAFTMANIFEST",
  ADD_WAYBILLNUMBERS_TO_DRAFTMANIFEST: "ADD_WAYBILLNUMBERS_TO_DRAFTMANIFEST",
  REMOVE_FROM_DRAFTMANIFEST: "REMOVE_FROM_DRAFTMANIFEST",
  CLEAR_DRAFTMANIFEST: "CLEAR_DRAFTMANIFEST",
  SET_DRAFT_MANIFEST_CLIENT_ID: "SET_DRAFT_MANIFEST_CLIENT_ID",
};
